import React from "react";
import ContactForm from "../tools/ContactForm";
import { Reveal } from "../tools/Reveal";
import { RevealGroup } from "../tools/RevealGroup";

// icons
import mailIcon from "../images/maintenance/mail.svg";
import locationIcon from "../images/maintenance/location.svg";
import phoneIcon from "../images/maintenance/telephone.svg";
import githubIcon from "../images/maintenance/github.svg";
import linkedinIcon from "../images/maintenance/linkedin.svg";
import fiverIcon from "../images/maintenance/fiverr.svg";
import "../styles/ContactMe.css";

function ContactMe() {
  return (
    <section className="main-container" id="contact-me">
      <RevealGroup>
        <div className="main-contact">
          <div className="section-title-wrapper">
            <Reveal direction={"top"}>
              <h4 className="section-title">CONTACT</h4>
              <h2 className="section-subtitle">Always Happy to Connect</h2>
            </Reveal>
          </div>
          <div className="contact-section-wrapper">
            <div className="contact-side">
              <Reveal direction={"left"}>
                <div className="contact-details-wrapper">
                  <h4 className="contact-detail-title">Reach Me At</h4>
                  <p className="contact-text">
                    Please feel free to contact me about new projects or
                    opportunities.
                  </p>
                  <div className="contact-info-wrapper">
                    <div className="contact-info">
                      <img src={locationIcon} alt="a location pin" /> Rotterdam,
                      Netherlands
                    </div>
                    <div className="contact-info">
                      <img src={mailIcon} alt="an envelope" />{" "}
                      canselenferidun@gmail.com
                    </div>
                    <div className="contact-info">
                      <img
                        src={phoneIcon}
                        alt="a minimalistic old phone handle"
                      />{" "}
                      +31 648599645
                    </div>
                  </div>
                  <div className="contact-social-icon">
                    <a
                      href="https://github.com/Feridun12"
                      target="_blank"
                      rel="noreferrer"
                      className="social-icon-wrapper"
                    >
                      <img
                        src={githubIcon}
                        alt="github logo"
                        className="social-icon"
                      />
                    </a>
                    <a
                      href="https://www.linkedin.com/in/feriduncanselen/"
                      target="_blank"
                      rel="noreferrer"
                      className="social-icon-wrapper"
                    >
                      <img
                        src={linkedinIcon}
                        alt="linkedIn logo"
                        className="social-icon"
                      />
                    </a>
                    <a
                      href="https://www.fiverr.com/s/38RDZo9"
                      target="_blank"
                      rel="noreferrer"
                      className="social-icon-wrapper"
                    >
                      <img
                        src={fiverIcon}
                        alt="fiverr logo"
                        className="social-icon"
                      />
                    </a>
                  </div>
                </div>
              </Reveal>
            </div>
            <div className="contact-side">
              <Reveal direction={"right"}>
                <ContactForm />
              </Reveal>
            </div>
          </div>
        </div>
      </RevealGroup>
    </section>
  );
}

export default ContactMe;
